import axiosInstance from "../AxiosInstance";
import { GET_CLASSIFIER_CONFIG, UPDATE_CLASSIFIER_CONFIG } from "./ClassifierEndpoints";

export function getClassifierConfig() {
  return axiosInstance.get(GET_CLASSIFIER_CONFIG);
}

export function updateClassifierConfig(data) {
  return axiosInstance.put(UPDATE_CLASSIFIER_CONFIG, data);
}
